import { useSearch } from "wouter";
import { Seo } from "@/components/Seo";
import { Section, PageHeader } from "@/components/Section";
import { LegalProse } from "@/components/LegalProse";
import {
  CURRENT_CONNECTID_TERMS_VERSION,
  getConnectIdTermsVersion,
  listConnectIdTermsVersions,
} from "./versions";

export default function ConnectIdTerms() {
  const search = useSearch();
  const requested = new URLSearchParams(search).get("v");
  const { entry, isCurrent, isKnown } = getConnectIdTermsVersion(requested);
  const Body = entry.ConnectIdTerms;
  const path = isCurrent
    ? "/legal/connectid-terms"
    : `/legal/connectid-terms?v=${entry.version}`;
  const lede = isCurrent
    ? `Last updated ${entry.lastUpdatedLabel}. These terms govern your workspace's use of ConnectID through FortifyID, as required by Australian Payments Plus.`
    : `Archived version published ${entry.lastUpdatedLabel}. This is a historical copy preserved for workspaces that accepted this version. The current ConnectID terms are at /legal/connectid-terms.`;

  return (
    <>
      <Seo
        title={
          isCurrent
            ? "ConnectID Minimum Customer Terms"
            : `ConnectID Minimum Customer Terms (${entry.version})`
        }
        description="The ConnectID Minimum Customer Terms that apply to your workspace's use of ConnectID through FortifyID."
        path={path}
      />
      <Section>
        <PageHeader
          eyebrow={
            isCurrent
              ? "Legal · ConnectID Minimum Customer Terms"
              : `Legal · ConnectID Minimum Customer Terms · Archived ${entry.version}`
          }
          title="ConnectID Minimum Customer Terms"
          lede={lede}
        />
        <LegalProse>
          {requested && !isKnown ? (
            <p>
              <em>
                The ConnectID terms version <code>{requested}</code> is not in
                our archive. Showing the current version (
                {CURRENT_CONNECTID_TERMS_VERSION}) instead.
              </em>
            </p>
          ) : null}
          <Body />
          <hr />
          <p className="text-sm">
            <strong>Version archive.</strong> Every published version of these
            ConnectID terms is preserved here so any workspace that accepted an
            earlier copy can review the exact wording it agreed to:
          </p>
          <ul className="text-sm">
            {listConnectIdTermsVersions().map((v) => (
              <li key={v.version}>
                <a href={`/legal/connectid-terms?v=${v.version}`}>
                  {v.version} — published {v.lastUpdatedLabel}
                </a>
                {v.version === CURRENT_CONNECTID_TERMS_VERSION
                  ? " (current)"
                  : null}
              </li>
            ))}
          </ul>
        </LegalProse>
      </Section>
    </>
  );
}
